var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardTtDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8975 12.7419L16.16 19.8469C16.1742 19.9306 16.1624 20.0166 16.1264 20.0934C16.0903 20.1702 16.0317 20.2342 15.9583 20.2768C15.8849 20.3194 15.8003 20.3385 15.7157 20.3317C15.6311 20.3249 15.5507 20.2924 15.485 20.2386L12.5017 17.9994C12.3577 17.8918 12.1827 17.8337 12.003 17.8337C11.8232 17.8337 11.6482 17.8918 11.5042 17.9994L8.51587 20.2378C8.4503 20.2915 8.36992 20.3239 8.28545 20.3307C8.20098 20.3376 8.11643 20.3185 8.04309 20.276C7.96975 20.2335 7.9111 20.1697 7.87497 20.0931C7.83884 20.0164 7.82694 19.9305 7.84087 19.8469L9.10254 12.7419",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.667C14.7614 13.667 17 11.4284 17 8.66699C17 5.90557 14.7614 3.66699 12 3.66699C9.23858 3.66699 7 5.90557 7 8.66699C7 11.4284 9.23858 13.667 12 13.667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTtDark);
export default __webpack_public_path__ + "static/media/dashboard-tt-dark.6b09d3f7a11fa3b85837419151f541a2.svg";
export { ForwardRef as ReactComponent };